// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OP8Kp","icon":"styles_icon__13-1g"};